enum ArrowClickCategory {
  NextVideo = "next_video",
  PreviousVideo = "prev_video",
}

export { ArrowClickCategory };